import TestLayout from "@/pcomponents/test/layout/layout";
import { useState, useEffect } from 'react';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import SearchOptArea from "./area/search_opt";
import ListArea from "./area/list";

function ExcuteListPage(props: any) {
  let myProps = {
    ...props
  };

  const [listOpt, setListOpt] = useState<any>({
    "server_num": "main",
    "table": "",
    "get_col": "*",
    "is_count": "1",
    "limit_num": "100",
    "where_str": "",
  });

  const [infoArr, setInfoArr] = useState<any>([]);
  const [count_info, set_count_info] = useState<any>({ tot: 0 });
  useEffect(() => {

  }, []);

  const get_list_by_ajax = (inData: any) => {
    let change_list_obj = {
      ...listOpt,
      ...inData
    };
    setListOpt(change_list_obj);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/test/mytest/sql_list', change_list_obj, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          if (response.data.data["info_arr"]) {
            setInfoArr(response.data.data["info_arr"]);
            set_count_info(response.data.data["count_info"]);
          }
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  return (
    <TestLayout>
      <SearchOptArea
        listOpt={listOpt}
        setListOpt={setListOpt}
        get_list_by_ajax={get_list_by_ajax}
      ></SearchOptArea>
      <div className="mt-2">
        <span>총건수: {count_info.tot}</span>
        <div className="mt-1">
          <ListArea
            infoArr={infoArr}
          ></ListArea>
        </div>
      </div>
    </TestLayout>
  );
};
export default ExcuteListPage;